import { render, staticRenderFns } from "./ScheduleAppointment.vue?vue&type=template&id=2ef32f6c&scoped=true&"
import script from "./ScheduleAppointment.vue?vue&type=script&lang=ts&"
export * from "./ScheduleAppointment.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleAppointment.vue?vue&type=style&index=0&id=2ef32f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef32f6c",
  null
  
)

export default component.exports